// Product status flow: draft → learning → clarifying → demo_ready → published
export var ProductStatus;
(function (ProductStatus) {
    ProductStatus["DRAFT"] = "draft";
    ProductStatus["LEARNING"] = "learning";
    ProductStatus["CLARIFYING"] = "clarifying";
    ProductStatus["DEMO_READY"] = "demo_ready";
    ProductStatus["PUBLISHED"] = "published";
})(ProductStatus || (ProductStatus = {}));
export const APP_PLATFORM_LABELS = {
    web: 'Web App',
    android: 'Android',
    ios: 'iOS',
};
export const APP_PLATFORM_ICONS = {
    web: 'Globe',
    android: 'Smartphone',
    ios: 'Tablet',
};
/**
 * PRODUCT BOUNDARIES (review §5.4) — one owner-editable list over five existing
 * stores, none of which changes shape. The API maps each kind to its key on
 * write and back on read (apps/api/.../products/boundaries.service.ts):
 *
 *   dont_claim    intelligence.guardrails.dontClaim[]
 *   limitation    intelligence.guardrails.limitations[]
 *   competitor    intelligence.guardrails.competitors[]
 *   dont_mention  intelligence.dontMention          (ONE string, '; '-joined)
 *   never_claim   intelligence.knowledgePack.neverClaim[].text
 */
export const BOUNDARY_KINDS = ['dont_claim', 'limitation', 'competitor', 'dont_mention', 'never_claim'];
// Product Clarifications
export var ClarificationStatus;
(function (ClarificationStatus) {
    ClarificationStatus["PENDING"] = "pending";
    ClarificationStatus["ANSWERED"] = "answered";
    ClarificationStatus["SKIPPED"] = "skipped";
})(ClarificationStatus || (ClarificationStatus = {}));
export var ClarificationArtifactType;
(function (ClarificationArtifactType) {
    ClarificationArtifactType["DEMO_PATH"] = "demo_path";
    ClarificationArtifactType["GUARDRAIL"] = "guardrail";
    ClarificationArtifactType["FAQ"] = "faq";
    ClarificationArtifactType["GLOSSARY"] = "glossary";
    ClarificationArtifactType["UI_MAP"] = "ui_map";
    ClarificationArtifactType["ROLE_CONSTRAINT"] = "role_constraint";
})(ClarificationArtifactType || (ClarificationArtifactType = {}));
// Demo Blueprint
export var BlueprintStatus;
(function (BlueprintStatus) {
    BlueprintStatus["DRAFT"] = "draft";
    BlueprintStatus["TESTING"] = "testing";
    BlueprintStatus["VALIDATED"] = "validated";
    BlueprintStatus["PUBLISHED"] = "published";
})(BlueprintStatus || (BlueprintStatus = {}));
export var ScheduledDemoStatus;
(function (ScheduledDemoStatus) {
    ScheduledDemoStatus["SCHEDULED"] = "scheduled";
    ScheduledDemoStatus["STARTED"] = "started";
    ScheduledDemoStatus["COMPLETED"] = "completed";
    ScheduledDemoStatus["CANCELLED"] = "cancelled";
    ScheduledDemoStatus["NO_SHOW"] = "no_show";
})(ScheduledDemoStatus || (ScheduledDemoStatus = {}));
// Meeting Sessions
export var MeetingSessionStatus;
(function (MeetingSessionStatus) {
    MeetingSessionStatus["CREATED"] = "created";
    MeetingSessionStatus["ACTIVE"] = "active";
    MeetingSessionStatus["ENDED"] = "ended";
    MeetingSessionStatus["ERROR"] = "error";
})(MeetingSessionStatus || (MeetingSessionStatus = {}));
//# sourceMappingURL=product.js.map